export default {
      id: "icon-user-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-user",
      toString: function () {
        return this.url;
      }
    }